import MarkdownIt from 'markdown-it';
import type Token from 'markdown-it/lib/token.mjs';

const md = MarkdownIt('zero', { html: false });

md.enable([
	'fence',
	'code',
	'emphasis',
	'backticks',
	'link',
	'image',
	'strikethrough',
	'escape',
	'entity',
	'newline',
]);

const collectText = (tokens: Token[]): string => {
	let result = '';
	for (const token of tokens) {
		if (token.children && token.children.length > 0) {
			result += collectText(token.children);
		} else if (
			token.type === 'text' ||
			token.type === 'code_inline' ||
			token.type === 'fence' ||
			token.type === 'code_block'
		) {
			result += token.content;
		} else if (token.type === 'softbreak' || token.type === 'hardbreak') {
			result += ' ';
		}
	}
	return result;
};

export const stripMarkdown = (input: string): string => {
	const tokens = md.parse(input, {});
	return collectText(tokens).trim();
};
